import { useNavigate } from "react-router-dom";
import {
	type FinancesNavigationState,
	FinancesOrigin,
	IncomeBackTo,
} from "web_myplann/Finances/Types/FinancesNavigationState";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";

export const useFinancialBalanceNavigation = () => {
	const navigate = useNavigate();

	const goToDetail = () =>
		navigate(Routing.Finances.Intro.path(), {
			state: {
				from: FinancesOrigin.Dashboard,
			} satisfies FinancesNavigationState,
		});

	const goToStart = () =>
		navigate(Routing.Finances.Income.path(), {
			state: {
				from: FinancesOrigin.Dashboard,
				incomeBackTo: IncomeBackTo.Dashboard,
			} satisfies FinancesNavigationState,
		});

	return { goToDetail, goToStart };
};
